import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FloatingDropdown = ({ options = [], buttonClass = '', menuClass = '' }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };
        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    return (
        <div className="relative inline-block text-start" ref={ref}>
            <button
                type="button"
                className={`flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 transition ${buttonClass}`}
                onClick={() => setOpen((prev) => !prev)}
                aria-haspopup="true"
                aria-expanded={open}
            >
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <circle cx="5" cy="12" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="19" cy="12" r="2" />
                </svg>
            </button>
            {open && (
                <div
                    dir="inherit"
                    className={`absolute right-0 rtl:left-0 rtl:right-auto z-50 mt-2 w-48 origin-top-right rtl:origin-top-left rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none text-start ${menuClass}`}
                >
                    <div className="py-1">
                        {options.map((option, idx) => (
                            <button
                                key={idx}
                                type="button"
                                className="w-full flex flex-row items-center justify-start gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition text-start"
                                onClick={() => {
                                    setOpen(false);
                                    option.onClick && option.onClick({navigate});
                                }}
                            >
                                {option.icon && <span className="flex flex-shrink-0 items-center">{option.icon}</span>}
                                <span className="min-w-0 flex-1 text-start">{option.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FloatingDropdown;
